import { getActiveField } from "./getActiveField";

export const getFormData = (fields, hideInactiveFields) => {
  if (!fields) return [];

  if (hideInactiveFields) {
    const activeFields = fields
      .map((field) => getActiveField(field))
      .filter((field) => !!field);

    return activeFields;
  }

  return fields;
};
